import React from 'react';
import AddBooks from './AddBooks';
import Book from './Book';

const BookList = () => (
  <div>
    <Book />
    <AddBooks />
  </div>
);

export default BookList;
